/**
 * Geo-aware shop links. Pages are rendered with the default shop URL
 * (cache-safe); this swaps [data-shop-link] hrefs with the visitor's
 * country shop. One request per browser session.
 */
const KEY = 'curaden-shop-url';

export function initShopLinks( endpoint ) {
	const links = document.querySelectorAll( 'a[data-shop-link]' );
	if ( ! endpoint || ! links.length ) {
		return;
	}
	const apply = ( url ) => url && links.forEach( ( a ) => ( a.href = url ) );

	let cached = null;
	try {
		cached = sessionStorage.getItem( KEY );
	} catch ( e ) {}
	if ( cached ) {
		apply( cached );
		return;
	}

	fetch( endpoint, { credentials: 'omit', headers: { Accept: 'application/json' } } )
		.then( ( r ) => ( r.ok ? r.json() : null ) )
		.then( ( data ) => {
			if ( data && data.url ) {
				apply( data.url );
				try {
					sessionStorage.setItem( KEY, data.url );
				} catch ( e ) {}
			}
		} )
		.catch( () => {} );
}
